<template>
  <div>
      <CCol col="12" sm="6" lg="3">
        Welcome to Oceanbolt internal admin.

      </CCol>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {

  data() {
    return {
      users: {}
    };
  },
  async mounted() {
    await this.getUsers();
  },
  methods: {
    ...mapActions(["listUsers"]),
    login() {
      // this.$auth.loginWithRedirect();
    },
  },
};
</script>

<style scoped>
.myIframe {
     min-width: 600px;
     position: relative;
     padding-bottom: 65.25%;
     padding-top: 30px;
     height: 0;
     overflow: auto;
     -webkit-overflow-scrolling:touch;
     border: solid black 1px;
}
.myIframe iframe {
     position: absolute;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
}
</style>
